import styled from  'styled-components';
import { Modal } from 'react-bootstrap';

import { AddCalenderButton } from '../MainEvents/styles';

const BoldFont = 'Rubik-Medium';

const StyledModal = styled(Modal)`
  .modal-dialog {
    width: ${(props) => props.$width || '25%'};
    
  
    margin-top: 100px;
    .modal-content{
      border:none !important;
      border-radius: 7px 7px 6px 6px;
      height: ${(props) => props.$height || ""}; 
    }
    .modal-header {
      background: none;
      border-radius: 6px 6px 0px 0px;
      border:none
    }
    .modal-body{
      padding: 0px 0 0 0;
      ${'' /* height: 454px; */}
      overflow-y: auto;
      .text{
        color: #184A61;
        text-align: center;
        font-family: Lato;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
      }
      img {
          width: 48px;
          height: 48px;
          border-radius: 50%;
      }
      ::-webkit-scrollbar {
       width: 10px;
     }

::-webkit-scrollbar {
   width: 5px;
   height: 5px;
 }
  ::-webkit-scrollbar-thumb {
   background: #BDBDBD;
   cursor: pointer;
   border-radius: 2.5px;
 }

::-webkit-scrollbar-track {
  background: #FEFEFE; 
  border-radius: 6px;
}
 

    }
    @media (max-width: 1000px) {
      width: 60%;
    }
    
    @media (max-width: 767px) {
      width: 90%;
      margin: 30px auto;ffffff
    }
  }

  .downloadButton{
    display: flex;
    justify-content: center;
    margin: 20px auto 12px auto;
  }
`;

const CustomTitle = styled(Modal.Title)`
  float: left;
  width: 100%;
  
  > div {
    float: left;
    width: 100%;
    display: flex;
    > div {
      font-size: 12px;
      color: #a9a9a9;
      display: flex;
    }
  
    > span {
      font-size: 16px;
      letter-spacing: 0px;
      font-family: Lato;
      color: #184A61;
      width: 90%;
      font-weight: 700;
      line-height: 24px;
      ${'' /* margin: auto; */}

      .attendeeCount {
       font-style: normal;
       font-weight: 700;
       padding-right:5px;
       font-size: 16px;
      }
    }
    .closeImage{
      width: 10%;
      display: flex;
      justify-content: flex-end;
      cursor:pointer;
      >img{
        width: 20px;
        height: 20px;
        cursor: pointer;
        margin-left: 15px;
        margin: auto;
        margin-right: 0px;
        margin-left: 15px;
      }
      .print{
        width:40px;
        height:40px;
        border-radius: 6px;
        cursor: pointer;
        display:flex;
        background: #FFFFFF1A;
        border-radius:3px;
        >img{
          height: 22px;
          width: 22px;
          display:flex;
          margin:auto;
        }
        >span{
          font-family:Rubik;
          font-weight:400;
          font-size:16px;
          line height:2.5px;
          text-align: center;
          color: #0D4270;
        }
      }
    }
  }

  .sub-title{
  color: #184A61;
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px; 
margin-top:12px;
}

  @media (max-width: 500px) {
    padding: 0 10px;
  }
`;

const PrintListButton = styled(AddCalenderButton)`
  margin-top: 0;
  float: right;
  font-size: 12px;
  > span {
    float: none;
  }

  @media (max-width: 450px) {
    float: left;
    margin-top: 10px;
  }
`;

const ContentWrapper = styled.div`
  width: 100%;
  /* height: 100%; */
  padding: ${({isRowPadding}) => isRowPadding ? isRowPadding : '8px 24px'};
  display: inline-block !important;
  > div {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex !important;
    align-items: center;
    .attendeeInfo{
      width: 80%;
      margin: auto;
      >span{
        font-size: 16px;
        color: #184A61;
        font-family: Lato;
        line-height: 20px;
        font-weight: 400;
      }
      >p{
        color: #669db7;
        font-size: 14px;
        font-family: rubik;
        margin: 0px;
        line-height: 16px;
      }
    }
    .image {
      width: 60px !important;
      height: 60px !important;
      margin-right: 12px;
      display:flex;
      justify-content:center;
      align-items: center;
      > img {
        width: 48px!important;
        height: 48px !important;
        border-radius: 60px;
        float: left;
        margin: auto;
      }
    }
  
    > span {
      margin-left: ${({marginLeft}) => marginLeft ? '5px' : '5px'};
      font-size: 18px;
      letter-spacing: 0px;
      color: rgb(21,159,202);
      font-family: ${BoldFont};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 80%;
      @media(max-width : 1025px) {
        margin-left: ${({marginLeft}) => marginLeft ? '15px' : '5px'};
      }
      @media(max-width : 500px) {
        margin-left: ${({marginLeft}) => marginLeft ? '5px' : '5px'};
      }
    }
  }

  @media (max-width: 500px) {
    width: 100%;
  }
`;

const NoGuests = styled.div`
  width: 100%;
  padding: 30px;
  font-size: 16px;
  font-family: Lato;
  color: #184A61;

`;

const AddBuddyButtonContainer = styled.div`
  width: 30%;
`;

const AddBuddyButtons = styled.div`
display: flex;
justify-content: center;
width: 100%;
background: ${({background}) => background ? background : 'blue'};
color: white;
font-family: rubik-medium;
font-size: 16px;
padding: 10px;
border: none;
border-radius: 3px;
cursor: pointer;
`;

export { StyledModal, CustomTitle, PrintListButton, ContentWrapper, NoGuests, AddBuddyButtonContainer, AddBuddyButtons };